export const Logo = ({ size = 34 }) => (
  <span className="inline-flex items-center gap-2.5">
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <path
        fill="#C85A32"
        d="M32 6c11 0 22 7 24 18 2 10-3 21-12 26-9 6-22 6-30-1C6 42 3 30 8 20 13 11 22 6 32 6z"
      />
      <path fill="#FBF8F3" d="M20 22l8 20h6l8-20h-7l-4 12-4-12z" />
      <circle fill="#E5A93C" cx="47" cy="15" r="6" />
    </svg>
    <span className="font-display text-xl font-semibold tracking-tight" style={{ color: "var(--ink)" }}>
      Visual<span style={{ color: "var(--terra)" }}>MA</span>
    </span>
  </span>
);
